import React, { useEffect } from 'react';
import Navbar from '../components/Navbar';
import Contact from '../components/Contact';

import proj_management_banner from '../assets/project_management_banner.jpg'
import proj_management from '../assets/proj_management.webp'

const ProjectManagement = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />

      {/* Hero Section */}
      <div className='mt-20 relative'>
        <div className='relative mt-[6rem]'>
          <img
            className='w-full h-[40rem] blur-sm object-cover'
            src={proj_management_banner}
            alt='Project Management at Jyotinay Analytics'
          />
          <div className='container mx-auto absolute inset-0 flex flex-col items-center justify-center px-4 text-center'>
            <p className='text-white text-3xl md:text-5xl font-bold'>
              Project Management at Jyotinay Analytics
            </p>
            <p className='text-white text-base md:text-xl mt-4 md:mt-8 max-w-3xl'>
              Deliver smarter, faster, and better. We align strategy with execution through agile project management built for impact.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className='container mx-auto mt-12 px-4'>
        <div className='max-w-3xl mx-auto text-left'>
          <p className='text-base md:text-lg leading-relaxed'>
            Successful projects don’t just happen — they’re planned, tracked, and guided from start to finish.
            At Jyotinay Analytics, our project management services ensure your initiatives stay on track,
            on time, and within budget. We bring clarity, collaboration, and control to every phase of your project.
          </p>

          <img
            className='w-full md:w-[30rem] h-[15rem] object-cover mt-8 rounded-lg shadow-md mx-auto'
            src={proj_management}
            alt='Project Management Planning'
          />

          {/* Why Project Management Section */}
          <div className='mt-12'>
            <h2 className='text-xl md:text-2xl font-semibold mb-4'>
              Why Choose Our Project Management Services?
            </h2>

            <p className='mb-4 text-base md:text-lg leading-relaxed'>
              Our team blends traditional frameworks with modern agile methodologies, ensuring smooth execution
              while adapting to your evolving needs. Whether it’s launching a new product or executing a digital transformation,
              we help you drive results.
            </p>

            <p className='mb-6 text-base md:text-lg leading-relaxed'>
              With our hands-on support and digital tools, your teams collaborate better, risks are minimized,
              and outcomes are delivered efficiently.
            </p>

            <ul className='list-disc ml-6 space-y-2 text-base md:text-lg'>
              <li>End-to-end project planning and execution</li>
              <li>Agile, Scrum, and hybrid methodologies</li>
              <li>Timeline, resource, and risk management</li>
              <li>Transparent reporting with project dashboards</li>
              <li>Stakeholder alignment and progress tracking</li>
            </ul>
          </div>
        </div>
      </div>
      {/* Contact Form */}
      <Contact />
    </div>
  );
};

export default ProjectManagement;
